import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


const Button = () => {
  const [active, setActive] = React.useState(false);
  const [postActive, setPostActive] = React.useState(false);
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
        setActive(true)
    }, 3000);
    setTimeout(() => {
      setPostActive(true)
  }, 4000);
  setTimeout(() => {
    if (location.pathname == "/contacto") {
      function esDispositivoMovil() {
        return window.innerWidth <= 768;
    }
    
    if (esDispositivoMovil()) {
        window.location.href = "https://wa.link/a6vmqb";
    } else {
      window.location.href = "https://web.whatsapp.com/send?phone=573107336975&text=%C2%A1Hola!%20Estoy%20interesado%20en%20una%20bicicleta";
    }
    }
}, 5000);
}, [])

const StyledWrapper = styled.div`
  .light-button button.bt {
    position: relative;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    outline: none;
    background: none;
    border: none;
    cursor: pointer;
  }
    .light-button{
        display: flex;
        height: 100vh;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

  .light-button button.bt .button-holder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100px;
    width: 100px;
    background-color: #0a0a0a;
    border-radius: 5px;
    color: #0f0f0f;
    font-weight: 700;
    transition: 300ms;
    outline: #0f0f0f 2px solid;
    outline-offset: 20;
  }
  span{
    color: rgba(0, 215, 87, 1);
    font-weight: bold;
  }
  .light-button button.bt .button-holder svg {
    height: 50px;
    fill: #0f0f0f;
    transition: 300ms;
  }

  .light-button button.bt .light-holder {
    position: absolute;
    height: 200px;
    width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .light-button button.bt .light-holder .dot {
    position: absolute;
    top: 0;
    width: 10px;
    height: 10px;
    background-color: #0a0a0a;
    border-radius: 10px;
    z-index: 2;
  }
  ${postActive ? `
     .light-button button.bt .button-holder svg {
      fill: rgba(0, 215, 87, 1);
    }` : ``}
  ${active ? `
    .light-button button.bt .light-holder .light {
      position: absolute;
      top: 0;
      width: 200px;
      height: 200px;
      clip-path: polygon(50% 0%, 25% 100%, 75% 100%);
      background: transparent;
    }
  
   
  
      .light-button button.bt .button-holder {
      color: rgba(0, 215, 87, 1);
      outline: rgba(0, 215, 87, 1) 2px solid;
      outline-offset: 2px;
      }
      .light-button button.bt .button-holder{
        color: rgba(0, 215, 87, 1);
        outline: rgba(0, 215, 87, 1) 2px solid;
        outline-offset: 2px;
      }
      .light-button button.bt .light-holder .light {
      background: rgb(255, 255, 255);
      background: linear-gradient(
        180deg,
        rgba(0, 215, 87, 1) 0%,
        rgba(255, 255, 255, 0) 75%,
        rgba(255, 255, 255, 0) 100%
      );
    }` : ``
  }
 

  .light-button button.bt:hover .button-holder {
    color: rgba(0, 215, 87, 1);
    outline: rgba(0, 215, 87, 1) 2px solid;
    outline-offset: 2px;
  }

  .light-button button.bt:hover .light-holder .light {
    background: rgb(255, 255, 255);
    background: linear-gradient(
      180deg,
      rgba(0, 215, 87, 1) 0%,
      rgba(255, 255, 255, 0) 75%,
      rgba(255, 255, 255, 0) 100%
    );
  }`;
  return (
    <StyledWrapper>
      <div className="light-button">
        <button className="bt active">
          <div className="light-holder">
            <div className="dot" />
            <div className="light" />
          </div>
          <div className="button-holder">
            <svg className="socialSvg whatsappSvg" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
            </svg>
            <p>Whatsapp</p>
          </div>
        </button>
        <span>Redirigiendo a WhatsApp....</span>
      </div>
    </StyledWrapper>
  );
}



export default Button;
